import React, { useState } from 'react';
import { Menu } from 'antd';
import { Link, useLocation } from "react-router-dom";
import { TableOutlined, DashboardOutlined } from '@ant-design/icons';
import css from './MainMenu.module.css';
import { checkUserRole } from '../../utils/helpers'

export const MainMenu = () => {
	const currentUser = JSON.parse(localStorage.getItem("user"));
	const role = currentUser?.role;
	
	const items = [
	  {
		key: 'stock',
		icon: <TableOutlined />,
		label: 'Stock',
		children: [
		  {
			key: 'stock_sales',
			label: 'Stock and Sales',
			children: [
			  {
				key: 'dashboard',
				label: <Link to='/dashboard'>Dashboard</Link>
			  }
			],
		  },
		],
	  },
	  {
		  key: 'admin',
		  icon: <TableOutlined />,
		  label: 'Admin',
		  role: 'admin',
		  children: [
			{
			  key: 'report_uploader',
			  label: <Link to='/report/upload'>Report Uploader</Link>
			},
			{
			  key: 'report_logs',
			  label: <Link to='/report/logs'>Import Logs</Link>
			},
			{
				key: 'users',
				label: <Link to='/admin/users'>User Management</Link>,
				role: 'label_admin|admin',
			},

		  ],
		}

	];
	
	const filterMenuItems = (menuItems) =>
		menuItems
		  .filter((item) => checkUserRole(role, item.role)) 
		  .map((item) => ({
			...item,
			children: item.children ? filterMenuItems(item.children) : undefined,
		  }));
	
	const filteredItems = filterMenuItems(items);

	
	const [current, setCurrent] = useState('dashboard');
	
	const onClick = (e) => {
		setCurrent(e.key);
	};

  return (
  	<Menu
			onClick={onClick}
			className={css.mainMenu}
			mode="inline"
			selectedKeys={[current]}
			defaultOpenKeys={['stock']}
			items={filteredItems}
		/>	
  )
}